<template>
    <div>
        <h1 class="title is-3 between-center">
            <span>Dob Permit Types</span>
            <div class="field is-grouped">
                <p v-if="hasCheckedRows" class="control">
                    <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                </p>
                <p class="control">
                    <button @click="handleCreate" class="button is-info" ><span class="icon"><i class="icm-new"></i></span><span>New</span></button>
                </p>
            </div>
        </h1>
        <div class="columns">
            <div class="column">
                <o-table
                        v-bind="table"
                        :data="dobPermitTypes"
                        :selected.sync="selected"
                        :checked-rows="checkedRows"
                        @update:checkedRows="$event => checkedRows = $event"
                        default-sort="user.first_name"
                >
                    <o-table-column #default="{ row }" field="description" label="Description" sortable>
                        {{ row.title }}
                    </o-table-column>

                    <o-table-column #default="{ row }" field="code" label="Code" sortable>
                        {{ row.code }}
                    </o-table-column>

                    <o-table-column #default="{ row }" field="status" label="Status" sortable>
                        {{ row.is_active ? 'Active' : 'Inactive' }}
                    </o-table-column>

                    <o-table-column #default="{ row }" label="">
                        <o-dropdown hoverable position="bottom-left" class="table-actions">
                            <button class="button" slot="trigger">
                                <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                            </button>
                            <o-dropdown-item has-link><a @click.stop.prevent="handleEdit(row)">Edit</a></o-dropdown-item>
                        </o-dropdown>
                    </o-table-column>

                    <template #empty>
                        <div class="has-text-centered">
                            This table is empty!
                        </div>
                    </template>
                </o-table>
            </div>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="editModalActive">
            <dob-permit-type-modal :item="editItem" />
        </o-modal>
    </div>
</template>

<script>
    import Table from './../../mixins/Table'
    import {mapActions, mapGetters} from 'vuex'
    import DobPermitTypeModal from '../../components/modals/DobPermitType'

    export default {
        mixins: [Table],

        components: {
            DobPermitTypeModal,
        },

        data() {
            return {
                editModalActive: false,
                editItem: {}
            }
        },

        computed: {
            ...mapGetters(['dobPermitTypes'])
        },

        mounted() {
            this.fetchPermitTypes()
        },

        methods: {
            ...mapActions({
                fetchPermitTypes: 'fetchPermitTypes',
                removeItem: 'removePermitType'
            }),

            handleCreate() {
                this.editItem = {}
                this.editModalActive = true
            },

            handleEdit(item) {
                this.editItem = item
                this.editModalActive = true
            }
        }
    }
</script>
